import {DynamicCrudService, OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {ApiPathsService} from "../../../app/api-paths.service";
import {CouponType, CouponTypeObject, stampa_id} from "./SanPellegrino";
import {dateTimeStringToFormattedDate, getDateYear} from "../../Utility/DateUtility";


function campoCustom(nome: string, valore:((coupon,parent?)=>string )| string) {
  return {
    nome: nome, oggetti: ["prezzo"], type: 'html', func: (coupon, parent?) => [typeof valore == "string" ? valore : valore(coupon,parent)]
  }
}

export function workingDaysDiff(start: Date, end: Date): number {
  const startDate = new Date(start);
  const endDate = new Date(end);

  // Normalizzo orari per evitare problemi di timezone
  startDate.setHours(0, 0, 0, 0);
  endDate.setHours(0, 0, 0, 0);

  // Ordine corretto
  let from = startDate < endDate ? startDate : endDate;
  let to = startDate < endDate ? endDate : startDate;

  let workingDays = 0;

  while (from < to) {
    const day = from.getDay(); // 0 = dom, 6 = sab
    if (day !== 0 && day !== 6) {
      workingDays++;
    }
    from.setDate(from.getDate() + 1);
  }

  return workingDays;
}

export function reportkpi(): OggettoConfig {
  var OBJ: OggettoConfig = {
    Id: "reportkpi",
    fullListRoute: "/prodotti/list",
    RestRoute: "/prodotti",
    ListDefaultFilter: {tipo: 50},
    FullExportExcel:true,
    ListResponseHasData:true,
    MenuItems: [
      {
        path: "/sanpellegrino/shared/dynamiclist/reportkpi",
        title: "Report Kpi",
        icon: "fa-solid fa-truck-fast",
        class: "",
        capacita: [],
        ruoliOperativi:["S", "SA"],

      },
      {
        path: "/sanpellegrino/shared/dynamiclist/reportkpi",
        title: "Report Kpi",
        icon: "fa-solid fa-truck-fast",
        class: "",
        capacita: ["gestione-prodotti"],

      },
    ],
    Filters:[
      CampoAggiuntivo.InputField("Codice Coupon", "prodotto", "text", "col-lg-9", ),
    ],

    Headers: [
      CampoAggiuntivo.InputField("Codice Coupon", "prodotto", "text", "", {modificabile: false}),
      campoCustom("Codice Prodotto", (coupon)=>coupon.correlatiObject?.reduce((a,correlato)=>`${a} ${correlato.prodotto}`,'')),
      campoCustom("Manager", (coupon) => coupon.dmCoupon?.fullName ?? coupon.namCoupon?.fullName ?? ""),
      campoCustom("Agente", (coupon) => coupon.agenteCoupon?.fullName ?? ""),
      campoCustom("Data Bonifico", (coupon)=> coupon?.dataBonifico ? dateTimeStringToFormattedDate(coupon?.dataBonifico) : ''),
      campoCustom("DDT", (coupon)=>coupon?.ddt?.map(x=>x.numero)?.join(", ")),
      campoCustom("Data DDT", (coupon)=>coupon?.ddt?.map(x=>dateTimeStringToFormattedDate(x?.data_prevista))?.join(", ")),
      campoCustom("KPI", (coupon)=> coupon?.ddt?.map(x=> workingDaysDiff(new Date(x?.data_prevista), new Date(coupon?.dataBonifico)))?.join(", ") )

    ],
    DisableEdit: true,
    AzioniLista: [
      {
        nome: 'Scarica',
        close: false,
        icon: 'fas fa-paperclip text-info ',
        class: ' btn ',
        single: true,
        labelClass: 'text-info ',
        hideif:{func:(coupon)=>coupon.ddt?.some(x=>x?.files?.length>0)},
        type: 'func',
        tooltip: "Scarica il DDT",
        func: (coupon, api:ApiPathsService, end, toastService) => {
          console.log('Scarica il ddt :' , coupon);
          coupon.ddt?.flatMap(ddt => ddt.files ?? []).forEach(file => api.DownloadFileByID(file.id));

        }

      },
      //TODO: Tasto Tracking
    ]
  }


  return OBJ;
}


